import { PropsWithChildren } from 'react';
import { SelectPopover, SelectPopoverProps } from '@ariakit/react';
import { DallasSpacing } from '@ui/Dallas/types/spacing';
import clsx from 'clsx';
import DallasCard from '@ui/Dallas/Card/DallasCard';
import styles from './DallasSelectPopover.module.scss';

interface Props extends SelectPopoverProps {
  className?: string;
  padding?: DallasSpacing;
}

export default function DallasSelectPopover({
  className,
  children,
  modal: isModal,
  store,
  padding = 'xs',
  ...selectPopoverProps
}: PropsWithChildren<Props>) {
  const isOpen = store?.useState('open') ?? false;
  return (
    isOpen && (
      <SelectPopover
        className={clsx(styles.root, isModal && styles.modal)}
        modal={isModal}
        store={store}
        {...selectPopoverProps}
      >
        <DallasCard
          className={clsx(className, styles.card)}
          padding={padding}
          gap="none"
          elevation={2}
          content={children}
        />
      </SelectPopover>
    )
  );
}
